import React from 'react';

import { useGraphQLQuery } from '@betterment/graphql';
import { Box, CenteredLayout } from '@betterment/samba-react';
import { useRequiredParam } from '@betterment/shared-components/src/hooks/useRequiredParam';

import { Accounts } from './Accounts';
import { GainsAndLossesCard } from './GainsAndLossesCard';
import { HouseholdMessagesDocument } from './graphql/query.householdMessages.generated';
import { HouseholdOverviewCard } from './HouseholdOverviewCard';

import MessageBox from '../../../Shared/message-box/message-box';
import { Layout } from '../../InstitutionalApp/Layout';
import { Header } from '../Header';

const Messages: React.FC = () => {
  const householdId = useRequiredParam('householdId');
  const { data } = useGraphQLQuery(HouseholdMessagesDocument, { variables: { id: householdId } });

  if (!data || data.household.__typename === 'RecordNotFoundResult') {
    return null;
  }

  return <MessageBox messages={data.household.messages} />;
};
export const Summary: React.FC = () => {
  return (
    <Layout active="clients">
      <Layout.Header>
        <Header />
      </Layout.Header>
      <Layout.Content>
        <CenteredLayout
          size="full"
          css={{
            gap: 'space.400',
          }}
        >
          <Messages />
          <Box
            css={{
              width: '100%',
              display: 'grid',
              gap: { base: 'space.100', sm: 'space.400' },
              gridAutoColumns: 'min-content',
              gridTemplateColumns: { base: '1fr', md: '1fr 1fr' },
            }}
          >
            <HouseholdOverviewCard />
            <GainsAndLossesCard />
          </Box>
          <Box
            css={{
              width: '100%',
              display: 'grid',
              gridAutoRows: 'max-content',
            }}
          >
            <Accounts />
          </Box>
        </CenteredLayout>
      </Layout.Content>
    </Layout>
  );
};
